module.exports = __webpack_public_path__ + "static/DarksideDetective5-b746584f879cf14f5b83ed0d43f31e47.webp";